module.exports = __webpack_public_path__ + "static/media/layout1-img.f94304fe.svg";